export default __webpack_public_path__ + "static/media/statistikk-graf-ikon.a32f567a.svg";